import {createApp} from 'vue';
import {createPinia} from 'pinia';
import '@fontsource/inter/300.css';
import '@fontsource/inter/700.css';
import './style/main.scss';
import './style/product.scss';
import './style/interior.scss';
import {router} from './router';
import App from './App.vue';
import {useSite} from './store';
const pinia=createPinia();
const app=createApp(App).use(pinia).use(router);
// Resolve the initial lazy route and its CSS before replacing the initial HTML.
async function start(){
  try{
    await router.isReady();
    if(!router.currentRoute.value.meta.standalone){
      await useSite(pinia).refresh().catch(()=>{});
    }
    app.mount('#app');
  }finally{
    document.documentElement.classList.remove('app-booting');
    clearTimeout((window as Window&{__appBootTimer?:ReturnType<typeof setTimeout>}).__appBootTimer);
  }
}
void start();
